import * as React from "react";

export const PrevArrowIcon = () => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#008CC9" fillRule="evenodd" clipRule="evenodd" d="M6.15407 0.973776C6.28027 1.10002 6.35116 1.27122 6.35116 1.44973C6.35116 1.62823 6.28027 1.79943 6.15407 1.92568L2.59101 5.48891H11.7366C11.9152 5.48891 12.0864 5.55984 12.2126 5.68609C12.3389 5.81234 12.4098 5.98357 12.4098 6.16211C12.4098 6.34065 12.3389 6.51188 12.2126 6.63813C12.0864 6.76438 11.9152 6.83531 11.7366 6.83531H2.59101L6.15407 10.3985C6.27669 10.5255 6.34454 10.6956 6.34301 10.8721C6.34147 11.0486 6.27068 11.2174 6.14587 11.3422C6.02106 11.4671 5.85222 11.5379 5.67572 11.5394C5.49922 11.5409 5.32917 11.4731 5.20221 11.3504L0.490062 6.63806C0.363863 6.51182 0.292969 6.34062 0.292969 6.16211C0.292969 5.9836 0.363863 5.8124 0.490062 5.68616L5.20221 0.973776C5.32845 0.847571 5.49964 0.776672 5.67814 0.776672C5.85664 0.776672 6.02783 0.847571 6.15407 0.973776V0.973776Z"/>
    </svg>
  )
}
export const NextArrowIcon = () => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#008CC9" fillRule="evenodd" clipRule="evenodd" d="M6.84556 0.973776C6.9718 0.847571 7.14299 0.776672 7.32149 0.776672C7.49999 0.776672 7.67118 0.847571 7.79742 0.973776L12.5096 5.68616C12.6358 5.8124 12.7067 5.9836 12.7067 6.16211C12.7067 6.34062 12.6358 6.51182 12.5096 6.63806L7.79742 11.3504C7.67046 11.4731 7.50041 11.5409 7.32391 11.5394C7.14741 11.5379 6.97857 11.4671 6.85376 11.3422C6.72895 11.2174 6.65816 11.0486 6.65662 10.8721C6.65509 10.6956 6.72294 10.5255 6.84556 10.3985L10.4086 6.83531H1.26301C1.08447 6.83531 0.913252 6.76438 0.787009 6.63813C0.660766 6.51188 0.589844 6.34065 0.589844 6.16211C0.589844 5.98357 0.660766 5.81234 0.787009 5.68609C0.913252 5.55984 1.08447 5.48891 1.26301 5.48891H10.4086L6.84556 1.92568C6.71936 1.79943 6.64847 1.62823 6.64847 1.44973C6.64847 1.27122 6.71936 1.10002 6.84556 0.973776V0.973776Z"/>
    </svg>
  )
}
export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         version="1.1"
         height="25"
         width="25">
      <g transform="translate(3.9661017,3.5677966)">
        <path strokeMiterlimit="4"
              fill="#FF3F33"
              stroke="#FF3F33"
              strokeWidth="3.23161912"
              strokeLinecap="round"
              d="M -2.5783352e-4,-0.00146808 17.435473,18.212367"/>
        <path strokeMiterlimit="4"
              fill="#FF3F33"
              stroke="#FF3F33"
              strokeWidth="3.23161912"
              strokeLinecap="round"
              d="M -2.5783352e-4,18.212367 17.435473,-0.00146808"/>
      </g>
    </svg>
  )
}
export const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path d="M8.9453 12.1155L15.0591 17.9995L20.9431 11.8857" stroke="#FF4E43" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )
}